module.exports = __webpack_public_path__ + "static/img/triple-berry-m.428e1a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/triple-berry-m.jpg
// module id = skPN
// module chunks = 0